@if (isOpen()) {
  <div class="bulk-download-panel bg-white position-fixed shadow overflow-hidden">
    <div class="d-flex align-items-center justify-content-between p-3 bg-primary text-white">
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-download fs-18"></i>
        <span class="fw-600">Downloads</span>
        @if (buildingCount() > 0) {
          <span class="badge rounded-pill bg-primary-light text-black fw-500">{{ buildingCount() }} Building</span>
        }
      </div>
      <div class="d-flex align-items-center gap-3">
        <i
          class="bi"
          [class.bi-chevron-up]="isCollapsed()"
          [class.bi-chevron-down]="!isCollapsed()"
          role="button"
          (click)="toggleCollapsed()"
        ></i>
        <i class="bi bi-x-lg" role="button" (click)="cancelAll()" title="Cancel all"></i>
      </div>
    </div>

    @if (!isCollapsed()) {
      <div class="bulk-download-panel__body overflow-auto">
        @for (job of jobs(); track job.jobId; let last = $last) {
          <div class="p-3" [class.border-bottom]="!last">
            <div class="d-flex align-items-start gap-2">
              @if (job.status === 'building') {
                <div
                  class="wh-32 rounded-circle bg-light d-flex align-items-center justify-content-center flex-shrink-0"
                >
                  <div class="spinner-border wh-12 text-muted"></div>
                </div>
                <div class="flex-fill">
                  <span class="fw-600 d-block">{{ fileCountLabel(job.fileIds.length) }}</span>
                  <p class="text-muted mb-0 fs-14">Building your ZIP...</p>
                  @if (job.fileNames.length) {
                    <p class="text-muted fs-12 mb-0 text-truncate text-wrap">{{ job.fileNames.join(', ') }}</p>
                  }
                </div>
              } @else if (job.status === 'failed') {
                <div
                  class="wh-32 rounded-circle bg-danger-subtle d-flex align-items-center justify-content-center flex-shrink-0"
                >
                  <i class="bi bi-exclamation-triangle fs-16 text-danger"></i>
                </div>
                <div class="flex-fill">
                  <span class="fw-600 d-block">{{ fileCountLabel(job.fileIds.length) }}</span>
                  <p class="text-danger mb-2 fs-14">We couldn't build your ZIP. Please try again.</p>
                  <button type="button" class="btn btn-outline-danger btn-h35" (click)="retry(job)">
                    <i class="bi bi-arrow-repeat"></i>Retry
                  </button>
                </div>
              } @else {
                <div
                  class="wh-32 rounded-circle bg-success-subtle d-flex align-items-center justify-content-center flex-shrink-0"
                >
                  <i class="bi bi-check-lg fs-20 text-success"></i>
                </div>
                <div class="flex-fill">
                  <span class="fw-600 d-block">{{ fileCountLabel(job.fileIds.length) }}</span>
                  <p class="text-success mb-2 fs-14">Your ZIP is ready</p>
                  <div class="d-flex align-items-center gap-2">
                    <button type="button" class="btn btn-primary btn-h35" (click)="download(job)">
                      <i class="bi bi-download"></i>Download ZIP
                    </button>
                    <span class="text-muted fs-12">Link expires in 15 min</span>
                  </div>
                </div>
              }

              @if (job.status !== 'building') {
                <i
                  class="bi bi-x fs-24 text-muted flex-shrink-0"
                  role="button"
                  (click)="dismiss(job.jobId)"
                  title="Dismiss"
                ></i>
              }
            </div>
          </div>
        }
      </div>

      <div class="d-flex align-items-center justify-content-between p-2 border-top">
        <span class="text-muted fs-12">Runs in the background — keep working.</span>
        @if (hasFinishedJobs()) {
          <a role="button" class="fs-12 fw-600 text-primary text-decoration-none" (click)="clearFinished()"
            >Clear Finished</a
          >
        }
      </div>
    }
  </div>
}
